/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const COMMON_STATES = {
  success: ["approved", "accepted", "success"],
  failed: ["denied", "rejected", "failed"],
  pending: ["pending", "processing", "loading"],
  missing: ["missing", "not found", "not available"],
  initial: ["initial", ""],
};
const commonStatesProcessor = (word) => {
  for (const [key, words] of Object.entries(COMMON_STATES)) {
    if (words.includes(word) || word === key) return key;
  }
  return "initial";
};

export const UIStateEnum = {
  initial: "initial",
  success: "success",
  failed: "failed",
  pending: "pending",
  missing: "missing",
}


const UI_STATES = {
  initial: UIStateEnum.initial,
  success: UIStateEnum.success,
  failed: UIStateEnum.failed,
  pending: UIStateEnum.pending,
  missing: UIStateEnum.missing,
};

const stateProxyHandler = {
  get: (UI_STATES, name) => {
    const state = commonStatesProcessor(name);
    return state;
  },
};

// Proxy will intercept the get operations on the object and process the given word to the processor
const STATES = new Proxy(UI_STATES, stateProxyHandler);

export default STATES;

